import DefaultMainPage from '../../pages/DefaultMainPage';
import PushCampaign from './PushCampaign';

const pushCampaignMenuItems = [
    {path: '/push-campaign', component: <PushCampaign/>, label: '푸시 캠페인'},
];

export const pushCampaignRoutes = {
    path: '/push-campaign',
    component: <DefaultMainPage buttons={pushCampaignMenuItems}/>,
    children: pushCampaignMenuItems,
};